var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.567,
    height: 20.408,
    viewBox: "0 0 18.567 20.408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-share-2",
    "data-name": "Icon feather-share-2",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2851",
    "data-name": "Path 2851",
    d: "M28.022,5.761A2.761,2.761,0,1,1,25.261,3a2.761,2.761,0,0,1,2.761,2.761Z",
    transform: "translate(-11.455 -3)",
    fill: "none",
    stroke: "#211e41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2852",
    "data-name": "Path 2852",
    d: "M10.022,16.261A2.761,2.761,0,1,1,7.261,13.5,2.761,2.761,0,0,1,10.022,16.261Z",
    transform: "translate(-4.5 -7.057)",
    fill: "none",
    stroke: "#211e41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2853",
    "data-name": "Path 2853",
    d: "M28.022,26.761A2.761,2.761,0,1,1,25.261,24,2.761,2.761,0,0,1,28.022,26.761Z",
    transform: "translate(-11.455 -11.114)",
    fill: "none",
    stroke: "#211e41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2854",
    "data-name": "Path 2854",
    d: "M12.885,20.265l6.286,3.663",
    transform: "translate(-7.74 -9.671)",
    fill: "none",
    stroke: "#211e41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2855",
    "data-name": "Path 2855",
    d: "M19.162,9.765l-6.277,3.663",
    transform: "translate(-7.74 -5.614)",
    fill: "none",
    stroke: "#211e41",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.c5a5ac5cd7f8fb7c4887e390617a9fd2.svg";
export { ForwardRef as ReactComponent };